export enum StatusEtapaGerenciarEmplacamentosEnum {
  FINALIZADO = 'finalizado',
  PENDENTE = 'pendente',
  PROCESSANDO = 'processando',
  ERRO = 'erro',
}
